const KeenSlider = window.KeenSlider

const { breakpoints } = window.BAO.MediaBreakpoints
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    if (this.externalEls.section?.exists) {
      this.updateAltImageClass()
    }
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.7,
          spacing: 1,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.sm}px)`]: {
            slides: {
              perView: 2.6,
              spacing: 1,
            },
          },
          [`(min-width: ${breakpoints.md}px)`]: {
            slides: {
              perView: 4.6,
              spacing: 1,
            },
          },
          [`(min-width: ${breakpoints.lg}px)`]: {
            slides: {
              perView: 5.6,
              spacing: 1,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  updateAltImageClass () {
    let handles = this.externalEls.section.element.dataset.altImageProducts
    if (!handles) return
    handles = handles.split(',')

    this.els.slide?.elements.forEach((slideEl) => {
      const handle = slideEl.dataset.productHandle
      if (!handles.includes(handle)) return
      slideEl.classList.add('clc-ProductGrid-imageModel')
    })
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
